import { PATHS } from "@/constants/path"
import { signal } from "@preact/signals"
import { signalWithStorage } from "@/utils/signal_utils"

const isGlifeUserRaw = (() => {
    const url = new URL(location.href)
    const pathname = url.pathname
    const searchParams = new URLSearchParams(location.search)
    const glife_token = searchParams.get("token")
    return pathname === PATHS.GLIFE_REDIRECT_USER && !!glife_token
})()

const LazadaCode = signalWithStorage<string | null>("", "LazadaCode")

const isLazadaminiUserRaw = (() => {
    const url = new URL(location.href)
    const pathname = url.pathname
    const searchParams = new URLSearchParams(location.search)
    LazadaCode.value = searchParams.get("authCode")
    return pathname === PATHS.LAZADAMINI_REDIRECT && !!LazadaCode.value
})()

const MayaCode = signalWithStorage<string | null>("", "MataCode")

const isMayaminiUserRaw = (() => {
    const url = new URL(location.href)
    const pathname = url.pathname
    const searchParams = new URLSearchParams(location.search)
    const MayaSessionId = searchParams.get("sessionId")
    MayaCode.value = MayaSessionId
        ? new TextDecoder().decode(Uint8Array.from(atob(MayaSessionId), (c) => c.charCodeAt(0)))
        : ""
    return pathname === PATHS.MAYAMINI_REDIRECT && !!MayaCode.value
})()

const isGlifeUser = signal(isGlifeUserRaw)
const isKycRouterCheckerActive = signal(true)

const isLazadaminiUser = signalWithStorage<boolean>(
    isLazadaminiUserRaw,
    "isLazadaminiUser",
    sessionStorage,
)
const isMayaminiUser = signalWithStorage<boolean>(
    isMayaminiUserRaw,
    "isMayaminiUser",
    sessionStorage,
)

function openGCashApp() {
    const APP_iD = "2170020210553950"
    const finalUrl = `https://gcashapp.page.link/?link=https://gcash.splashscreen/?redirect%3Dgcash%3A%2F%2Fcom.mynt.gcash%2Fapp%2F006300121300%3FappId%3D${APP_iD}%2526page%253Dpages%252Findex%252Findex%2526apn%253Dcom.globe.gcash.android%2526isi%253D520020791%2526ibi%253Dcom.globetel.gcash&apn=com.globe.gcash.android&isi=520020791&ibi=com.globetel.gcash`
    const finalUrlString = finalUrl.toString()
    location.href = finalUrlString
}

const AppSignals = {
    isGlifeUser() {
        return isGlifeUser.value
    },
    setGlifeUser(value: boolean) {
        isGlifeUser.value = value
    },
    openGCashApp,
    isKycRouterCheckerActive,
    turnOnKycRouterChecker() {
        isKycRouterCheckerActive.value = true
    },
    turnOffKycRouterChecker() {
        isKycRouterCheckerActive.value = false
    },

    isLazadaminiUser() {
        return isLazadaminiUser.value
    },
    setLazadaminiUser(value: boolean) {
        isLazadaminiUser.value = value
    },
    isMayaminiUser() {
        return isMayaminiUser.value
    },
    setMayaminiUser(value: boolean) {
        isMayaminiUser.value = value
    },
}

export default AppSignals
